import React from "react";
import ReactToggle from "react-toggle";
import "./Toggle.less";

const Toggle = (props) => {
  return <ReactToggle {...props} />;
};

export default Toggle;
